import React, { useContext } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { CardContext, ICardContext } from 'context/cardContext';
import './CardRevealCopy.scss';

const CardRevealCopy = () => {
  const { t } = useTranslation();
  const { revealTime, canBeRevealed, revealed, loading } = useContext<ICardContext>(CardContext);

  return (
    <div className="card-reveal-copy">
      {canBeRevealed && !revealed ? (
        <div className={`card-reveal-copy__cta ${loading ? 'card-reveal-copy__disable' : ''}`}>{t('reveal-now')}</div>
      ) : (
        <div className={`card-reveal-copy__content`}>
          {t('reveal-on')} <br /> {`${t(dayjs(revealTime).format('ddd').toLowerCase())}`} <span className="card-reveal-copy__content__at">@</span> {`${dayjs(revealTime).format('H:mm')}`}
        </div>
      )}
    </div>
  );
};

export default CardRevealCopy;
